import fm from 'format-message';
import PropTypes from 'prop-types';
import useSiteSelectorQuery from 'queries/useSiteSelectorQuery';
import Seo from '@activebrands/core-web/components/seo-meta/structured-data/Seo';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import JohaugIcon from 'components/icons/JohaugIcon';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
    height: '100vh',
    zIndex: 1,
    transition: 'transform var(--transition-fast)',
    overflowY: 'scroll',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'var(--color-text-inverted)',
});

const SiteSelectorLayout = ({ children, location }) => {
    const [css] = useStyletron();
    const { seo = {} } = useSiteSelectorQuery();
    const seoData = { content: { seo } };
    const year = new Date().getFullYear();

    return (
        <>
            <Seo data={seoData} location={location} />
            <Wrapper>
                <header
                    className={css({
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        padding: '16px',
                    })}
                >
                    <JohaugIcon width="108px" />
                </header>
                {children}
                <footer
                    className={css({
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: 'var(--color-bg-footer-primary)',
                        color: 'var(--color-text)',
                        padding: '16px',
                    })}
                >
                    <JohaugIcon width="80px" />
                    {fm('© { year } Johaug', {
                        year,
                    })}
                </footer>
            </Wrapper>
        </>
    );
};

SiteSelectorLayout.propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object,
};

export default SiteSelectorLayout;
